



















































import Vue, { PropType } from 'vue'
import forms from '@/mixins/forms-mixin'
import { FormField } from '@/types/Form.interface'
export default Vue.extend({
    mixins: [forms],
    props: {
        // The available fields to set
        availableFields: {
            type: Array,
            required: true
        },
        //  Disables our inputs
        disabled: {
            type: Boolean,
            default: false
        },
        // The input field
        input: {
            type: Object as PropType<FormField>,
            required: true
        }
    },
    data() {
        return {
            // Label clone
            tempLabel: null,
            //  Flag to check if we are loading
            loading: false
        }
    },
    mounted() {
        //  Start loading
        this.loading = true

        // Clone the label to compare against
        this.tempLabel = this.input.label

        // Update the available fields
        this.$emit('resetFields')

        // Set loading to false to start rendering the element
        this.loading = false
    },
    computed: {
        selectableFields(): object[] {
            //  Get the available fields as just text and value
            const fields = this.availableFields.map((x: FormField) => {
                return { text: x.name, value: x.name }
            })

            // Add self as option for fields
            fields.push({
                text: this.input.name,
                value: this.input.name
            })

            //  Return our fields
            return fields
        }
    },
    methods: {
        labelChange(event: Event) {
            //  Grab the src element of our event
            const src = event.target as HTMLInputElement

            // Get the value of the label
            const label = src.value

            // If label does not exist return
            if (!label) return

            //  If temp label is equal to the label, return
            if (this.tempLabel === label) return

            // Else label is edited, update the input's label
            this.input.label = label

            // Call updateForm in FormsProfile.vue
            this.$emit('change')
        },
        inputChange(input: FormField): void {
            // Get a new default input
            const newInput = this.getDefaultInput(input)

            // Copy id over from old input
            newInput.id = this.input.id

            // Copy properties over
            Object.assign(this.input, newInput)

            // Call updateForm in FormsProfile.vue
            this.$emit('change')
        }
    }
})
